import React from "react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Keep logging minimal but available in dev tools.
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error("Unhandled UI error:", error);
    }
  }

  handleReload = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <section
          style={{
            minHeight: "100vh",
            display: "grid",
            placeItems: "center",
            padding: "1.5rem",
            background: "linear-gradient(180deg, var(--bg-base), #fff)",
          }}
        >
          <div
            style={{
              maxWidth: "520px",
              textAlign: "center",
              border: "1px solid var(--border-soft)",
              borderRadius: "16px",
              padding: "1.4rem",
              background: "#fff",
            }}
          >
            <h2 style={{ color: "var(--text-strong)", marginBottom: ".7rem" }}>
              Something went wrong
            </h2>
            <p className="font-sans" style={{ color: "var(--text-body)", marginBottom: "1rem" }}>
              We hit an unexpected issue. Please reload and try again.
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              style={{
                border: "none",
                borderRadius: "999px",
                padding: ".7rem 1.2rem",
                background: "linear-gradient(90deg, var(--brand-main), #6f9279)",
                color: "#fff",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Reload App
            </button>
          </div>
        </section>
      );
    }

    return this.props.children;
  }
}
